import { RouteConfig } from 'vue-router';
import Layout from '@/layout/index.vue';

const issueRouter: RouteConfig = {
    path: '/issue',
    component: Layout,
    redirect: '/issue/index',
    children: [
      {
        path: '/issue/index',
        name: 'Issue',
        component: () => import('@/views/issue/index.vue'),
        meta: {
          title: 'route.issue',
          icon: 'iconxuqiu',
          activeMenu: ['/issue/index'],
          breadcrumb: [
            {title: 'route.issueList', path: '/issue/index'},
          ],
        },
      },
      {
        path: '/issue/create',
        name: 'CreateIssue',
        component: () => import('@/views/issue/createIssue.vue'),
        meta: {
          hidden: true,
          activeMenu: ['/issue/index'],
          title: 'route.createIssue',
          noCache: true,
          breadcrumb: [
            {title: 'route.issueList', path: '/issue/index'},
            {title: 'route.createIssue', path: '/issue/create'},
          ],
        },
      },
      {
        path: '/issue/update',
        name: 'UpdateIssue',
        component: () => import('@/views/issue/updateIssue.vue'),
        meta: {
          hidden: true,
          activeMenu: ['/issue/index'],
          title: 'route.updateIssue',
          noCache: true,
          breadcrumb: [
            {title: 'route.issueList', path: '/issue/index'},
            {title: 'route.updateIssue', path: '/issue/update'},
          ],
        },
      },
    ],
};

export default issueRouter;
